import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.LeaseOverlock1, LocationVarKey.LeaseOverlock2, LocationVarKey.LeaseOverlock3];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Overlock
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.LeaseOverlock1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.LeaseOverlock2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.LeaseOverlock3}
        enableSwitchVar={LocationVarKey.LeaseOverlock3Enabled}
      />
    </>
  );
}
